const _state = {
  skipSlides: {},
}

export default _state
